import { createAsyncThunk } from "@reduxjs/toolkit";
import { setAuthorization, APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";

const api = new APICore();

export const loginWithGoogle = createAsyncThunk(
  "auth/loginWithGoogle",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.LOGIN_WITH_GOOGLE, data);
      const user  = response.data.data;
      // save token for future requests
      setAuthorization(user.token);
      api.setLoggedInUser(user);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
